import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserDetails } from '../../store/slices/userSlice';
import { Button } from '../common/modal';
import './Footer.css';

const Footer = ({ onSignupClick }) => {
  const navigate = useNavigate();
  const userDetails = useSelector(selectUserDetails);
  const isLoggedIn = !!userDetails;

  return (
    <div className="bg-gray-900 text-gray-400 py-8 z-[100] mt-auto footer-override">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 mb-4">
          <Link to="/about-us" className="hover:text-white">
            About Us
          </Link>
          <span className="hidden sm:block">|</span>
          <Button
            onClick={(e) => {
              if (!isLoggedIn) {
                e.preventDefault();
                if (onSignupClick) {
                  onSignupClick();
                } else {
                  navigate('/');
                }
              } else {
                navigate('/learning');
              }
            }}
            className="hover:text-white"
          >
            Learning Center
          </Button>
          <span className="hidden sm:block">|</span>
          <Link to="/privacy" className="hover:text-white">
            Privacy Policy
          </Link>
          <span className="hidden sm:block">|</span>
          <Link to="/terms" className="hover:text-white">
            Terms of Service
          </Link>
          <span className="hidden sm:block">|</span>
          <Link to="/SupportPortal" className="hover:text-white">
            Help Center
          </Link>
        </div>
        <p className="text-sm">
          Copyright © {new Date().getFullYear()} OzChaim Digital LLC. PathFinder is operated by OzChaim Digital LLC. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
